/* RESPONSIBLE TEAM: team-automation-foundations */
import type CloseConversation from 'embercom/models/operator/visual-builder/step/close-conversation';
import StepConfig, { type StepConfigParams } from '../step';

export default class CloseConversationConfiguration extends StepConfig {
  declare step: CloseConversation;

  constructor(params: Omit<StepConfigParams, 'component'>) {
    super({
      component: 'workflows/graph-editor/node-items/steps/close-conversation',
      ...params,
    });
  }
}
